import axios from 'axios';

// from webpack define plugin
const baseURL = API_URL;

const instance = axios.create({ baseURL });

function setHeaders(token = null) {
    instance.defaults.headers.post['Content-Type'] = 'application/json';
    instance.defaults.headers.common['x-user-token'] = token;
}

const api = {
    generateUserToken: (token) => instance.post('/api/user/', { token }),
    // falsy значения не отправляются
    createRequest: ({
        name,
        email,
        phone,
        company,
        position,
        services,
    }) => instance.post('/api/request/', {
        name,
        email: email || undefined,
        phone: phone || undefined,
        company,
        position,
        services,
    }),
    // like: (caseID) => instance.post('/api/like/', { caseID }),
    // getServiceByID: (id) => instance.get(`/api/service/${id}`),
    getAllDirections: () => instance.get('/api/direction/'),
    getCases: (limit, skip, services) => instance.get('/api/case/', {
        params: {
            limit,
            skip,
            services,
        },
    }),
    getCaseByID: (id, limit, skip, services) => instance.get(`/api/case/${id}`, {
        params: {
            limit,
            skip,
            services,
        },
    }),
};

export default api;
export { setHeaders };
